import { render } from "./PartnerAppointmentsPage.vue?vue&type=template&id=f3374652"
import script from "./PartnerAppointmentsPage.vue?vue&type=script&lang=js"
export * from "./PartnerAppointmentsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__